// Standard app card (the look of the portfolio hub header cards): Material 3 filled card on surface-container-low,
// extra-large (28px) corners, no border. Use this for every content card so cards look the same across the app.
// Props: shape ('extra-large' default | 'large' | 'medium'), plus everything Card accepts (clickable, onClick, sx...).
(function () {
  // True inside a SurfaceCard: lets small things (like LabelPills) pick a compact size by themselves.
  const InCardContext = React.createContext(false);

  function SurfaceCard({ shape = 'extra-large', sx, ...props }) {
    const { Card } = window.Components;
    return (
      <InCardContext.Provider value={true}>
        <Card
          variant="filled"
          sx={[{ backgroundColor: 'var(--m3-surface-container-low)', borderRadius: `var(--m3-shape-${shape})` }, ...(Array.isArray(sx) ? sx : [sx])]}
          {...props}
        />
      </InCardContext.Provider>
    );
  }

  window.Components = window.Components || {};
  window.Components.SurfaceCard = SurfaceCard;
  window.Components.InCardContext = InCardContext;
})();
